
<!--!&#45;&#45; Hero Start &ndash;&gt;-->
<section class="bg-half-170 d-table w-100" id="home"
         style="background: url('assets/3r/transport.jpg') center center; background-size: 100%">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-6">

                <div class="title-heading mt-4">
                    <h1 class="display-4 font-weight-bold text-white title-dark mb-3" style="font-size: 38px !important;">You could always rely on our service for a wonderful, memorable and comfortable journey.</h1>
                    <p class="para-desc text-white-50">3R Travels is well equipped to provide ground transport for all your tour requirements and transfers in
                        Sri Lanka. Cars, Micro vans, mini busses and large coaches could be provided as per your requirement.
                        Our driver guides are well experienced and knowledgeable on various sites in the island and always at
                        your service to make sure your journey is a safe and a memorable one.</p>
<!--                    <div class="mt-4">-->
<!--                        <a href="javascript:void(0)" class="btn btn-icon btn-pills btn-lg btn-light">-->
<!--                            <i-feather name="arrow-down" class="icons"></i-feather>-->
<!--                        </a>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<!--end section-->
<div class="position-relative">
    <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>
<!-- Hero End -->
<div *ngIf="trans==null" class="row justify-content-center">
    <mat-spinner></mat-spinner>
</div>

<div class="row col-12 mt-5 mb-5">
    <div class="col-xl-4 col-lg-4 mb-3" *ngFor="let p of trans" >
        <div class="card img shadow-md"
             style=" height:15rem; background-size: cover; background: url({{p.url}});border-radius: 10px">
            <div class="bg-overlay" style="border-radius: 10px"></div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <h4 style="color: white">{{p.name}}</h4>
                        <!--                                    <p class="text-muted">He lay on his armour-like back, and if he lifted his head.</p>-->
                    </div>
                    <div class="col-12" style=" bottom: 10px;position: absolute;">
<!--                        <button class="btn btn-primary" style=" margin-top: 31px;" (click)="booking(p)">-->
<!--                            book now-->
<!--                        </button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--<div class="container mt-100 mt-60 mb-5" *ngFor="let t of trans">-->
<!--    <div class="row align-items-center">-->
<!--        <div class="col-lg-5 col-md-6">-->

<!--            <img src="{{t.url}}"  class="img-fluid rounded shadow-md" alt="">-->
<!--        </div>-->
<!--        &lt;!&ndash;end col&ndash;&gt;-->

<!--        <div class="col-lg-7 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0 " >-->
<!--            <div class="section-title ml-lg-4">-->
<!--                <h4 class="title mb-4">{{t.name}}</h4>-->
<!--                <p class="text-muted">{{t.description}}</p>-->
<!--&lt;!&ndash;                <ul class="list-unstyled text-muted">&ndash;&gt;-->
<!--&lt;!&ndash;                    <li class="mb-0"><span class="text-primary h5 mr-2"><i class="uim uim-check-circle"></i></span>Digital&ndash;&gt;-->
<!--&lt;!&ndash;                        Marketing Solutions for Tomorrow&ndash;&gt;-->
<!--&lt;!&ndash;                    </li>&ndash;&gt;-->
<!--&lt;!&ndash;                    <li class="mb-0"><span class="text-primary h5 mr-2"><i class="uim uim-check-circle"></i></span>Our&ndash;&gt;-->
<!--&lt;!&ndash;                        Talented&ndash;&gt;-->
<!--&lt;!&ndash;                        & Experienced Marketing Agency&ndash;&gt;-->
<!--&lt;!&ndash;                    </li>&ndash;&gt;-->
<!--&lt;!&ndash;                    <li class="mb-0"><span class="text-primary h5 mr-2"><i class="uim uim-check-circle"></i></span>Create&ndash;&gt;-->
<!--&lt;!&ndash;                        your&ndash;&gt;-->
<!--&lt;!&ndash;                        own skin to match your brand&ndash;&gt;-->
<!--&lt;!&ndash;                    </li>&ndash;&gt;-->
<!--&lt;!&ndash;                </ul>&ndash;&gt;-->
<!--&lt;!&ndash;                <a href="javascript:void(0)" class="mt-3 h6 text-primary">Search Destination <i&ndash;&gt;-->
<!--&lt;!&ndash;                        class="mdi mdi-chevron-right"></i></a>&ndash;&gt;-->

<!--                <div class="row">-->
<!--                    <button (click)="booking(t)" class="btn-sm btn  btn-primary mr-3 ml-3">Book now</button>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--        &lt;!&ndash;end col&ndash;&gt;-->
<!--    </div>-->
<!--    &lt;!&ndash;end row&ndash;&gt;-->
<!--</div>-->
<notifier-container></notifier-container>
